import { render, staticRenderFns } from "./TournamentJoinButton.vue?vue&type=template&id=48926eca&"
import script from "./TournamentJoinButton.vue?vue&type=script&lang=ts&"
export * from "./TournamentJoinButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports